import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, ButtonGroup, makeStyles } from '@material-ui/core';
import { ReportProblemOutlined } from '@material-ui/icons';
import { USER_OPERATIONS } from 'helper';
import { RootState } from 'interfaces';
import ApplicationAccidentDialog from 'pages/PageApplicationNew/components/ApplicationAccidentDialog';
import { useGetRealEstateAccidents } from './hooks';
import { RealEstateAccidents } from './components';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    maxWidth: 1366,
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 1000,
  },
});

interface IProps {
  realEstateId: string;
}

const View = ({ realEstateId }: IProps) => {
  // Global state
  const operations = useSelector((state: RootState) => state.operations);

  // Local state
  const [realEstateAccidentDialogOpened, setRealEstateAccidentDialogOpened] = useState(false);
  const [onlyActive, setOnlyActive] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 10;

  // Styles
  const classes = useStyles();

  const params = {
    onlyActive,
    pageNo,
    pageSize,
  };

  const { fetchRealEstateAccidents, data, error, loading } = useGetRealEstateAccidents();

  useEffect(() => {
    fetchRealEstateAccidents(realEstateId, params);
  }, [realEstateId, onlyActive, pageNo]); // eslint-disable-line react-hooks/exhaustive-deps

  const list = data.get(Object.values(params).filter(Boolean).join('-')) || { list: [], totalCount: 0 };

  return (
    <>
      <Box className={classes.root}>
        <Box sx={{ mb: 2 }}>
          <ButtonGroup>
            {operations.includes(USER_OPERATIONS.APPLICATION_ACCIDENT) && (
              <Button
                variant="outlined"
                onClick={() => setRealEstateAccidentDialogOpened(true)}
                startIcon={<ReportProblemOutlined />}
              >
                Зарегистрировать аварию
              </Button>
            )}

            {onlyActive && (
              <Button variant="outlined" onClick={() => setOnlyActive(false)}>
                Показать все аварии
              </Button>
            )}
          </ButtonGroup>
        </Box>

        <RealEstateAccidents
          data={list}
          error={error}
          loading={loading}
          onChangePage={setPageNo}
          page={pageNo}
          pageSize={pageSize}
        />
      </Box>

      <ApplicationAccidentDialog
        realEstateGuid={realEstateId}
        showRealEstateFormControl={false}
        open={realEstateAccidentDialogOpened}
        onSave={() => fetchRealEstateAccidents(realEstateId, params, false)}
        onClose={() => setRealEstateAccidentDialogOpened(false)}
      />
    </>
  );
};

export default View;
